<template>  
<div class="content mt-5">
    <b-container v-if="loading" class="text-center" fluid>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </b-container>
    <b-container v-if="!loading">   

    <b-card  header-tag="header" footer-tag="footer">
      <template #header>
        <h6 class="mb-0">Solicitudes</h6>
      </template>
      <b-card-text>   
 
        <b-row>
            <b-col  sm="12" md="8"> 
                    <b-button @click="agregarSolicitud()" size="sm" variant="success"  title="Aagregar solicitud">
                        <b-icon font-scale="" icon="plus" aria-hidden="true"></b-icon>
                            Agregar Solicitud
                    </b-button>  
             
            </b-col> 
            <b-col sm="12" md="4">
                <b-form-group class="pr-0 mr-0 text-right">
                    <b-button size="sm" :disabled="isBusy" @click="actualizar()" variant="primary">Actualizar</b-button>
                </b-form-group>    
            </b-col> 
        </b-row> 

        <b-row >
            <b-col sm="12">
                <b-row>  
                    <b-col sm="12" md="3" class="my-2 ml-0 pl-0 pr-0">
                        <b-form-group
                        label="por página"
                        label-for="per-page-select"
                        label-cols-md="6" 
                        label-cols-sm="12" 
                        label-align-sm="left"
                        label-size="sm"
                        class="mb-0 pl-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="9" sm="12" class="mr-0 pr-0 pl-0">

                        <b-form-group
                            label="Filtrar"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-input-group size="sm">
                                <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                placeholder="Filtrar"
                                ></b-form-input>

                                <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                         
                    </b-col>
                </b-row> 

                </b-col>
        </b-row>
        <b-row>
            <b-col>  
                <b-table 
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                :current-page="currentPage"
                stacked="md"
                :busy="isBusy"
                :Striped="true"
                show-empty
                small
                :outlined="true"
                :bordered="true"
                >   

                   <template #empty="scope">
                        <div class="text-center my-2"> 
                            No se encontraron resultados
                        </div>
                    </template>

             <template #cell(folio)="row">
                <b-button variant="link" size="sm" @click="download(row.item.folio, false)" class="mr-2">
                      {{ row.item.folio }} 
                </b-button>
             </template>
 

             <template #table-busy>
                <div class="text-center my-2"> 
                <b-spinner variant="primary" label="Spinning"></b-spinner> 
                </div>
            </template>
        </b-table>
        <b-row>

         <b-col sm="4"  class="my-1">
        
         </b-col>
         <b-col sm="4"  class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0" 
                ></b-pagination>
            </b-col>
        </b-row> 

        </b-col>
  
            
        </b-row>

                </b-card-text> 
    </b-card> 


    <b-card class="mt-3"  header-tag="header" footer-tag="footer">
      <template #header>
        <h6 class="mb-0">Incorporaciones</h6>
      </template>
      <b-card-text>   
 
        <b-row> 
            <b-col sm="12">
                <b-form-group class="pr-0 mr-0 text-right">
                    <b-button size="sm" :disabled="isBusyInco" @click="actualizarIncorporacion()" variant="primary">Actualizar</b-button>
                </b-form-group>    
            </b-col> 
        </b-row> 

        <b-row >
            <b-col sm="12">
                <b-row>  
                    <b-col sm="12" md="3" class="my-2 ml-0 pl-0 pr-0">
                        <b-form-group
                        label="por página"
                        label-for="per-page-select"
                        label-cols-sm="6" 
                        label-align-sm="left"
                        label-size="sm"
                        class="mb-0 pl-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPageIncorporacion"
                            :options="pageOptions"
                            size="sm"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="9" sm="12" class="mr-0 pr-0 pl-0"> 

                        <b-form-group
                            label="Filtrar"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-input-group size="sm">
                                <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                placeholder="Filtrar"
                                ></b-form-input>

                                <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                         
                    </b-col>
                </b-row> 

                </b-col>
        </b-row>
        <b-row>
            <b-col>  
                <b-table 
                :items="itemsIncorporaciones"
                :fields="fieldsIncorporaciones"
                :per-page="perPageIncorporacion"
                :filter="filter"
                :filter-included-fields="filterOn"
                :current-page="currentPageIncorporacion"
                stacked="md"
                :busy="isBusyInco"
                :Striped="true"
                show-empty
                small
                :outlined="true"
                :bordered="true"
                >  
                    <template #empty="scope">
                    <div class="text-center my-2"> 
                        No se encontraron resultados
                    </div>
                    </template> 

             <template #cell(folio)="row">
                <b-button variant="link" size="sm" @click="download(row.item.folio, true)" class="mr-2">
                      {{ row.item.folio }} 
                </b-button>
             </template>
 

             <template #table-busy>
                <div class="text-center my-2"> 
                <b-spinner variant="primary" label="Spinning"></b-spinner> 
                </div>
            </template>
        </b-table>
        <b-row>

         <b-col sm="4"  class="my-1">
        
         </b-col>
         <b-col sm="4"  class="my-1">
                <b-pagination
                v-model="currentPageIncorporacion"
                :total-rows="totalRowsIncorporaciones"
                :per-page="perPageIncorporacion"
                align="fill"
                size="sm"
                class="my-0" 
                ></b-pagination>
            </b-col>
        </b-row> 

        </b-col>
  
              
        </b-row>

                </b-card-text> 
    </b-card> 
    </b-container> 
</div> 
</template>
<style scoped>
    /* .cl_100 {
        width: 180px !important;
    } */
</style>
 
<script>  


import axios from 'axios'  
import moment from 'moment'
import Swal from 'sweetalert2'  
import { seePDFServel } from "./../utils/pdfHelper"
moment.locale('es') 


export default {
    name: "Solicitudes",
    components: {  
    },
    data: function () {
    return {
        items : [],
        itemsIncorporaciones : [],
        regiones: [],
        comunas: [],
        filters: {
            id: '',
            issuedBy: '',
            issuedTo: ''
        }, 
        loading : true, 
        isBusy: false,
        isBusyInco: false,
        fields: [
            { key: 'folio', label: 'Folio', class: 'text-center', sortable: true }, 
            { key: 'fecha_solicitud', label: 'Fecha', class: 'text-center', sortable: true }, 
            { key: 'nom_origen', label: 'Origen', class: 'text-center', sortable: true }, 
            { key: 'nombre_completo', label: 'Nombre Solicitante', class: 'text-center', sortable: true }, 
        ], 
        fieldsIncorporaciones: [
            { key: 'folio', label: 'Folio', class: 'text-center', sortable: true }, 
            { key: 'fecha_solicitud', label: 'Fecha', class: 'text-center', sortable: true }, 
            { key: 'nom_origen', label: 'Origen', class: 'text-center', sortable: true }, 
            { key: 'nombre_completo', label: 'Nombre Solicitante', class: 'text-center', sortable: true }, 
        ], 
        totalRows: 0,
        totalRowsIncorporaciones: 0,
        currentPage: 1,
        currentPageIncorporacion: 1,
        perPage: 5,
        perPageIncorporacion: 5,
        pageOptions: [2, 5, 10, 50],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
         
        }
    },  
    async created()
    { 
        this.$store.commit('SET_LAYOUT', 'LayoutExterno1')   
        
        this.loading = false 
        this.actualizar()  
        this.actualizarIncorporacion()  
        
 
    }, 
    methods: {  

        async actualizarIncorporacion(){
            this.isBusyInco = true
            await this.getIncorporaciones()
            this.isBusyInco = false

        },
        async actualizar(){
            this.isBusy = true
            await this.getSolicitudes()
            this.isBusy = false
        },
        async getIncorporaciones()
        { 
            const url = `${process.env.VUE_APP_API_URL  }/user/solicitudes/incorporacion`

            try {
                const { data : { solicitudes, statusCode, error}} = await axios.get(url) 

                if(statusCode!=200) throw error

                if(error) throw error

                this.totalRowsIncorporaciones = solicitudes.length
            
                this.itemsIncorporaciones = solicitudes

 
            } catch (error) {
                console.error("Error al consultar por las solicitudes")
                  this.loading = false
                console.error("Error al enviar el formulario:: ", error)
                return Swal.fire({
                    icon: 'error',
                    type: 'error',
                    text: error,
                    confirmButtonText: 'Aceptar',
                })
            }
        },
        async getSolicitudes()
        { 
            const url = `${process.env.VUE_APP_API_URL  }/user/solicitudes/cambio`

            try {
                const { data : { solicitudes, statusCode, error}} = await axios.get(url) 

                if(statusCode!=200) throw error

                if(error) throw error

                this.totalRows = solicitudes.length
            
                this.items = solicitudes

 
            } catch (error) {
                console.error("Error al consultar por las solicitudes::", error)
            }
        },
        async agregarSolicitud()
        {
 
            window.location = '/solicitar'
            
        },
        async download(folio, incorporacion)
        {

            const url = `${process.env.VUE_APP_API_URL  }/getcomprobante/${folio}/${incorporacion}` 

            try {
                this.loading = true
                const { data : { documento,  error}} = await axios.get(url)  

                if(error) throw error
                
                await seePDFServel(documento)

            } catch (error) {
                console.error("Error descargar el documento", error)
                
            } finally {
                this.loading = false
            }
        }
    
    }
}
</script>

<style>
</style>
